import { render, staticRenderFns } from "./addAdministrators.vue?vue&type=template&id=644bde36&scoped=true&"
import script from "./addAdministrators.vue?vue&type=script&lang=js&"
export * from "./addAdministrators.vue?vue&type=script&lang=js&"
import style0 from "./addAdministrators.vue?vue&type=style&index=0&id=644bde36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644bde36",
  null
  
)

export default component.exports